import createAction from '../../redux/createAction';
import lpActions from './lpActionTypes';

export const storeAuthorizedLpsAction = createAction(
  lpActions.SET_AUTHORIZED_LPS
);
export const storeAuthorizedDSPsAction = createAction(
  lpActions.SET_AUTHORIZED_DSPS
);
export const storeAuthorizedEntitiesAction = createAction(
  lpActions.SET_AUTHORIZED_ENTITIES
);
export const storeAuthorizedLpSelectedAction = createAction(
  lpActions.SET_SELECTED_LP
);
